import React from 'react'
import { connect } from 'react-redux'
import context from '@/context'
import { Main, MainTop, MainTopTitle, MainBody } from '@/components/Layout'
import { actionCreators } from '@/store/TemporaryFileAttachment'
import { BsrsGrid, DateCell, DateFilterCell } from '@/components/BsrsGrid'
import { GridColumn as Column, GridCell } from '@progress/kendo-react-grid'
import { DropDownList } from '@/components/dropDownList'

const data = ['null', 'false', 'true']
const verifiedCell = (props) => {
  return class extends GridCell {
    handleChange = (value, id) => {
      let verified
      switch (value) {
        case 'true': verified = true; break
        case 'false': verified = false; break
        default: verified = null; break
      }
      const input = {
        id,
        verified
      }
      props.updateVerifiedStatus(input)
    }
    render () {
      const value = `${this.props.dataItem[this.props.field]}`
      return <DropDownList
        data={data}
        onChange={({ value }) => this.handleChange(value, this.props.dataItem.id)}
        value={value}
      />
    }
  }
}

class TemporaryFileAttachments extends React.Component {
  render () {
    const { temporaryFiles, updateVerifiedStatus } = this.props
    return (
      <Main>
        <MainTop>
          <MainTopTitle>Temporary page: File attachments</MainTopTitle>
        </MainTop>
        <MainBody>
          <BsrsGrid
            dataSource={context.api.temporaryFileService.getTableData}
            lastReloadedAt={temporaryFiles.componentKey}>
            <Column field='id' title='Id' editable={false} filterable={false} />
            <Column field='name' title='Name' editable={false} />
            <Column field='contentType' title='Content type' editable={false} />
            <Column field='verified' title='Verified' editable={false} filterable={false} sortable={false} cell={verifiedCell({ updateVerifiedStatus })} />
            <Column field='creationTime' title='Creation time' editable={false} filter='date' cell={DateCell} filterCell={DateFilterCell} />
          </BsrsGrid>
        </MainBody>
      </Main>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    temporaryFiles: state.temporaryFiles,
    ...ownProps
  }
}

const mapDispatchToProps = {
  updateVerifiedStatus: actionCreators.updateVerifiedStatus
}

export default connect(mapStateToProps, mapDispatchToProps)(TemporaryFileAttachments)



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/TemporaryFileAttachments.js